import { render, staticRenderFns } from "./FieldGroupField.vue?vue&type=template&id=0d0260bb"
import script from "./FieldGroupField.vue?vue&type=script&lang=js"
export * from "./FieldGroupField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports